class Recaptcha {
    constructor() {
        this._reCaptcha3SiteKey = "";
        this._recaptchaLoaded = false;
        this.init();

        this.bindEvents();
    }

    init() {
        let _this = this;
        let _recaptchaWidgets = document.body.querySelectorAll('[data-id="widget-recaptcha"]');
        _recaptchaWidgets.forEach(function (widget) {
            let _key = widget.dataset.key;
            if (_key !== undefined) {
                _this._reCaptcha3SiteKey = _key;
            }
            widget.removeAttribute('data-key');
        });
    }

    bindEvents() {
        let _this = this;
        document.addEventListener("reCaptcha_domInjection", function (event) {
            event.preventDefault();
            _this.domInjection();
        });
        document.addEventListener('recaptcha3_generate_token', function (event) {
            _this.generateToken(event);
        });
        document.addEventListener('recaptcha_reset', function (event) {
            event.preventDefault();
            _this.resetRecaptcha()
        });
    }

    domInjection() {
        if (this._recaptchaLoaded === false) {
            this._recaptchaLoaded = true;
            this.loadRecaptcha2();
            this.loadRecaptcha3();
        } else {
            this.resetRecaptcha();
        }
    }

    loadRecaptcha2() {
        let script = document.createElement('script');
        let node = document.getElementsByTagName('body')[0];

        script.type = 'text/javascript';
        script.defer = true;
        script.src = 'https://www.google.com/recaptcha/api.js';
        node.appendChild(script);
    }

    loadRecaptcha3() {
        if (this._reCaptcha3SiteKey !== "") {
            let script = document.createElement('script');
            let node = document.getElementsByTagName('body')[0];

            script.type = 'text/javascript';
            script.defer = true;
            script.src = 'https://www.google.com/recaptcha/api.js?render=' + this._reCaptcha3SiteKey;
            node.appendChild(script);
        }
    }

    generateToken(event) {
        let _this = this;
        let _target = "";
        let _action = "undefinded";
        if (event.detail.origin !== undefined) {
            _target = event.detail.origin;
        }
        if (event.detail.action !== undefined) {
            _action = event.detail.action;
        }
        if (this._reCaptcha3SiteKey !== "") {
            grecaptcha.ready(function () {
                grecaptcha.execute(_this._reCaptcha3SiteKey, {action: _action}).then(function (token) {
                    let _eventDetail = {'detail': {'target': _target, 'token': token}};
                    let _event = new CustomEvent('recaptcha3_token_generated', _eventDetail);
                    document.dispatchEvent(_event);
                });
            });
        } else {
            let _eventDetail = {'detail': {'target': _target, 'token': ""}};
            let _event = new CustomEvent('recaptcha3_token_generated', _eventDetail);
            document.dispatchEvent(_event);
        }
    }

    resetRecaptcha() {
        let _recaptchaEl = document.querySelector('.g-recaptcha');
        if (typeof grecaptcha !== 'undefined' && _recaptchaEl !== null) {
            if (_recaptchaEl.innerHTML.trim() === '') {
                grecaptcha.render(_recaptchaEl, { sitekey: _recaptchaEl.dataset.sitekey });
            } else {
                grecaptcha.reset();
            }
        }
    }
}

export default Recaptcha